import React, { useRef, useState } from 'react'
import './SearchableProviderDropdown.scss'
import { isTestFeature } from '../../../utils/sharedFeaturesFunctions'
import { useOutsideClick } from '../../../hooks/useOutsideClick'

export default function SearchableProviderDropdown({
  providerMedicalCoding,
  options,
  selectedVal,
  handleChange,
}) {
  const [query, setQuery] = useState('')
  const [isOpen, setIsOpen] = useState(false)

  const ref = useRef(null)
  useOutsideClick(ref, () => setIsOpen(false))

  const selectOption = (option) => {
    setQuery('')
    handleChange({ provider_id: option?.provider_id, practice_id: option?.practice_id })
    setIsOpen(false)
  }

  const getDisplayValue = () => {
    if (isOpen) {
      return query
    } else if (selectedVal) {
      return selectedVal.name
    }

    return ''
  }

  const filter = (options) => {
    if (!query) {
      return options
    }

    return options.filter(
      (option) =>
        option.name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        option?.last_name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        option.first_name.toLowerCase().indexOf(query.toLowerCase()) > -1 ||
        option.name.replace(',', '').toLowerCase().indexOf(query.toLowerCase()) > -1,
    )
  }

  return (
    <div className="searchable-dropdown" style={{ width: 'fit-content' }} ref={ref}>
      <div className="control">
        <div className="selected-value">
          <input
            type="text"
            value={getDisplayValue() || ''}
            name="searchTerm"
            onChange={(e) => {
              setQuery(e.target.value)
            }}
            onClick={(e) => {
              setQuery('')
              setIsOpen(true)
            }}
            autoComplete={'off'}
          />
          {isTestFeature() && providerMedicalCoding !== false && (
            <i title={'Medical Coding ON'} className="fa-solid fa-briefcase-medical"></i>
          )}
        </div>
        <div className={`arrow ${isOpen ? 'open' : ''}`}></div>
      </div>

      {isOpen && (
        <div className={`options open`}>
          {filter(options).map((option) => {
            return (
              <div
                onClick={() => {
                  selectOption(option)
                }}
                className={`option ${
                  option?.provider_id === selectedVal?.provider_id ? 'selected' : ''
                }`}
                key={option?.provider_id}
              >
                {option?.name}
              </div>
            )
          })}
          {filter(options)?.length === 0 && <div className={`option`}>No results found</div>}
        </div>
      )}
    </div>
  )
}
